import { Submultiples } from "../../SIprefixe";
import { Unit, UnitBaseTypes } from "../../Units";

function Millimetre({ exponent }) {
  return <Unit unit={UnitBaseTypes.metre} prefix={Submultiples.milli} exponent={exponent} />;
}

export default Millimetre;
